<template>
  <div class="lesson-pdfs d-flex flex-wrap mx-n2">
    <a
      v-for="(pdf, index) in pdfs"
      class="btn btn-outline-secondary d-flex align-items-center m-2"
      :key="index"
      :href="pdf.file"
      target="_blank"
    >
      <i class="far fa-file-pdf"></i>
      <span class="mx-3">{{ pdf.name }}</span>
      <i class="fas fa-external-link-alt"></i>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    pdfs: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-pdfs {
  .btn {
    white-space: nowrap;
    font-weight: bold;
  }
}
</style>
